import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { Pagination, TableNoFilterResults } from '@morpho-org/ui-v6/client';
import { TableNoResults } from '@morpho-org/ui-v6/server';
import { ButtonLink } from '@/components/common/ButtonLink';
import { TableQueryError } from '@/components/common/Error';
import { Table, TrBodyRow, TrHeaderGroup } from '@/components/common/Table';
import { TableScrollArea } from '@/components/common/Table/CompactTable/Table';
import { getMarketsUrl } from '@/helpers/routing';
import { useDashboardBorrowActivityTable } from '../hooks/useDashboardBorrowActivityTable';
import { PARTIAL_TRANSACTIONS_NOTICE } from '../partialNotice.constants';
import DashboardBorrowActivityFilters from './DashboardBorrowActivityFilters';
const noBorderRadiusStyle = {
  borderRadius: '0'
};
const DashboardBorrowActivity = t0 => {
  const $ = _c(64);
  const {
    children
  } = t0;
  const {
    items,
    loading,
    partial,
    error,
    transactionsTable,
    hasNoTransactions,
    columnFilters,
    setColumnFilters,
    pagination,
    loadingRows
  } = useDashboardBorrowActivityTable();
  let availableTypes;
  let t1;
  if ($[0] !== items) {
    const itemTypes = items.map(_temp);
    const itemChainIds = items.map(_temp2);
    availableTypes = Array.from(new Set(itemTypes));
    t1 = Array.from(new Set(itemChainIds));
    $[0] = items;
    $[1] = availableTypes;
    $[2] = t1;
  } else {
    availableTypes = $[1];
    t1 = $[2];
  }
  const availableChains = t1;
  let t2;
  if ($[3] !== availableChains || $[4] !== availableTypes || $[5] !== columnFilters || $[6] !== setColumnFilters) {
    t2 = {
      filters: columnFilters,
      setColumnFilters,
      availableChains,
      availableTypes,
      withGlobalSearch: true
    };
    $[3] = availableChains;
    $[4] = availableTypes;
    $[5] = columnFilters;
    $[6] = setColumnFilters;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== t2) {
    t3 = <DashboardBorrowActivityFilters filterProps={t2}>{children}</DashboardBorrowActivityFilters>;
    $[8] = children;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== transactionsTable) {
    t4 = transactionsTable.getHeaderGroups().map(_temp3);
    $[11] = transactionsTable;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <Table.Thead>{t4}</Table.Thead>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== loading || $[16] !== loadingRows || $[17] !== transactionsTable) {
    t6 = loading ? loadingRows.map(_temp4) : transactionsTable.getRowModel().rows.map(_temp5);
    $[15] = loading;
    $[16] = loadingRows;
    $[17] = transactionsTable;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6) {
    t7 = <Table.Tbody>{t6}</Table.Tbody>;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t7) {
    t8 = <Table.Table tableVariant="compact-filter">{t5}{t7}</Table.Table>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== error || $[25] !== hasNoTransactions || $[26] !== items.length || $[27] !== loading || $[28] !== setColumnFilters) {
    t9 = !loading && hasNoTransactions && !error && <div className="border-border border-t-[0.5px]">{items.length === 0 ? <TableNoResults withBackground={false} withBorder={false} text="No Borrow activity yet." height="340px" style={noBorderRadiusStyle}><ButtonLink mode="internal" href={getMarketsUrl()} buttonProps={{
          label: "Browse markets"
        }} /></TableNoResults> : <TableNoFilterResults type="transactions" count={items.length} clearFilters={() => setColumnFilters?.([])} />}</div>;
    $[24] = error;
    $[25] = hasNoTransactions;
    $[26] = items.length;
    $[27] = loading;
    $[28] = setColumnFilters;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== error || $[31] !== loading) {
    t10 = !loading && error && <TableQueryError error={error} minHeight="340px" style={noBorderRadiusStyle} />;
    $[30] = error;
    $[31] = loading;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t8 || $[35] !== t9) {
    t11 = <TableScrollArea className="grid h-full w-full rounded-none rounded-b-[20px]">{t8}{t9}{t10}</TableScrollArea>;
    $[33] = t10;
    $[34] = t8;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== error || $[38] !== loading || $[39] !== partial) {
    t12 = partial && !loading && !error && <p className="text-secondary-foreground px-sm text-xs" data-testid="dashboard-borrow-activity-partial-notice">{PARTIAL_TRANSACTIONS_NOTICE}</p>;
    $[37] = error;
    $[38] = loading;
    $[39] = partial;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== transactionsTable) {
    t13 = transactionsTable.getRowCount();
    $[41] = transactionsTable;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  const t14 = transactionsTable.previousPage;
  const t15 = transactionsTable.nextPage;
  const t16 = transactionsTable.setPageIndex;
  let t17;
  if ($[43] !== transactionsTable) {
    t17 = transactionsTable.getCanPreviousPage();
    $[43] = transactionsTable;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== transactionsTable) {
    t18 = transactionsTable.getCanNextPage();
    $[45] = transactionsTable;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== error || $[48] !== loading || $[49] !== pagination || $[50] !== t13 || $[51] !== t17 || $[52] !== t18 || $[53] !== transactionsTable.nextPage || $[54] !== transactionsTable.previousPage || $[55] !== transactionsTable.setPageIndex) {
    t19 = <Pagination loading={loading} error={error} pagination={pagination} totalItemsCount={t13} previousPage={t14} nextPage={t15} setPage={t16} canPreviousPage={t17} canNextPage={t18} />;
    $[47] = error;
    $[48] = loading;
    $[49] = pagination;
    $[50] = t13;
    $[51] = t17;
    $[52] = t18;
    $[53] = transactionsTable.nextPage;
    $[54] = transactionsTable.previousPage;
    $[55] = transactionsTable.setPageIndex;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== t11 || $[58] !== t12 || $[59] !== t19) {
    t20 = <div className="gap-lg flex h-[100%] w-[100%] flex-col"><div className="gap-xs flex flex-col">{t11}{t12}{t19}</div></div>;
    $[57] = t11;
    $[58] = t12;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== t20 || $[62] !== t3) {
    t21 = <>{t3}{t20}</>;
    $[61] = t20;
    $[62] = t3;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  return t21;
};
export default DashboardBorrowActivity;
function _temp(item) {
  return item.type;
}
function _temp2(item_0) {
  return item_0.chainId;
}
function _temp3(headerGroup) {
  return <TrHeaderGroup key={headerGroup.id} headerGroup={headerGroup} />;
}
function _temp4(row, index) {
  return <TrBodyRow key={`skeleton-${index}`} skeletonRow={row} />;
}
function _temp5(row_0) {
  return <TrBodyRow key={`${row_0.id}-${row_0.original.type}`} row={row_0} />;
}